module.exports = __webpack_public_path__ + "img/gengduo.eb048d97.png";